import AssetView from "./AssetView.vue"
import AssetJobList from "./AssetJobList.vue"
import AssetEdit from "./AssetEdit.vue"

const base = "/asset"

export default [
    {
        path: base + "/:uuid",
        name: "assetdetailform",
        props: true,
        component: AssetView
    },
    {
        path: base + "/jobs/:uuid",
        name: "assetjoblist",
        props: true,
        component: AssetJobList
    },
    {
        path: base + "/:uuid/edit",
        name: "asseteditform",
        props: true,
        component: AssetEdit
    },
]
